module.exports = __webpack_public_path__ + "static/media/NoorPoster.f0554b88.jpg";